import "/__w/1/s/BotFramework-WebChat/packages/component/src/Activity/Bubble.module_built.css";
const classes = {"bubble--from-user":"wYVITZq_bubble--from-user","bubble":"wYVITZq_bubble","bubble__content":"wYVITZq_bubble__content","bubble__nub":"wYVITZq_bubble__nub","bubble__nub-pad":"wYVITZq_bubble__nub-pad","bubble--show-nub":"wYVITZq_bubble--show-nub","bubble__nub-outline":"wYVITZq_bubble__nub-outline","bubble--nub-on-top":"wYVITZq_bubble--nub-on-top","bubble--hide-nub":"wYVITZq_bubble--hide-nub"}
export default classes

const _bubble__from_user0 = classes["bubble--from-user"]
export { _bubble__from_user0 as "bubble--from-user" }

const _bubble0 = classes["bubble"]
export { _bubble0 as "bubble" }

const _bubble__content0 = classes["bubble__content"]
export { _bubble__content0 as "bubble__content" }

const _bubble__nub0 = classes["bubble__nub"]
export { _bubble__nub0 as "bubble__nub" }

const _bubble__nub_pad0 = classes["bubble__nub-pad"]
export { _bubble__nub_pad0 as "bubble__nub-pad" }

const _bubble__show_nub0 = classes["bubble--show-nub"]
export { _bubble__show_nub0 as "bubble--show-nub" }

const _bubble__nub_outline0 = classes["bubble__nub-outline"]
export { _bubble__nub_outline0 as "bubble__nub-outline" }

const _bubble__nub_on_top0 = classes["bubble--nub-on-top"]
export { _bubble__nub_on_top0 as "bubble--nub-on-top" }

const _bubble__hide_nub0 = classes["bubble--hide-nub"]
export { _bubble__hide_nub0 as "bubble--hide-nub" }
